export default "__VITE_ASSET__098bf5d6__"